import { CustomInputMappingField } from "../../../redux";

export interface CustomInputMappingFieldDivider extends CustomInputMappingField {
    subFields: CustomInputMappingField[]
}

export const isTitleDividingPresented = (fields: CustomInputMappingField[]) => {
    return fields.some(field => field.type === 'title')
}

type IsDividable = boolean
export type GetFieldAsDividing = [IsDividable, CustomInputMappingFieldDivider | CustomInputMappingField]

export const getFieldsAsDividing = (fields: CustomInputMappingField[]): GetFieldAsDividing[] => {
    const res: GetFieldAsDividing[] = []
    let isSub = false

    for (let index = 0; index < fields.length; index++) {
        const field = fields[index];
        if(field.type !== 'title') {
            if(!isSub) {
                res.push([false, field])
                continue
            }
            const last = res.slice(-1)[0]
            const f = last[1] as CustomInputMappingFieldDivider
            f.subFields.push(field)
            continue
        }
        //it's title
        isSub = true
        res.push([true, {...field, subFields: []}])
    }
    return res
}